import { Stack, TextField, Typography } from '@mui/material';
import { IPersonalDetails } from 'API';
import { FormSection, PhoneNumber, CustomCheckbox } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { generateError } from 'Regex';
import { store } from 'Store';
import { styleTextField } from 'Theme';
import { textFieldShrink } from 'Utils';

export const SecondSection = () => {
  const {
    register,
    formState: { errors },
    clearErrors,
    setValue,
  } = useFormContext<IPersonalDetails>();

  const isDesktop = useIsDesktop();

  const formInfo = store.getState().generalContent.formInfo;

  const [hasNoMail, hasNoExtraPhoneNumber, mail] = useWatch({
    name: [
      `contactInfoSection.hasNoMail`,
      `contactInfoSection.hasNoExtraPhoneNumber`,
      'contactInfoSection.mail',
    ],
  });

  const dictionary = useDictionary(Dictionary, DICTIONARY.PERSONAL_DETAILS);

  useEffect(() => {
    if (hasNoExtraPhoneNumber) {
      setValue('contactInfoSection.extraPhoneNumber', '');
      clearErrors('contactInfoSection.extraPhoneNumber');
    }
    if (hasNoMail) {
      setValue('contactInfoSection.mail', '');
      clearErrors('contactInfoSection.mail');
    }
  }, [clearErrors, setValue, hasNoExtraPhoneNumber, hasNoMail]);

  return (
    <FormSection>
      <Typography
        fontSize={isDesktop ? '18px !important' : '16px !important'}
        sx={{ fontWeight: 'bold' }}
      >
        {dictionary.secondSectionTitle}
      </Typography>
      <Typography>{dictionary.secondSectionSubTitle}</Typography>
      <Stack gap={isDesktop ? '32px' : '24px'}>
        <PhoneNumber
          phoneNumberFormName='contactInfoSection.phoneNumber'
          phoneNumberPrefixFormName='contactInfoSection.phonePrefixRelationId'
          phoneNumberError={Boolean(errors.contactInfoSection?.phoneNumber)}
          phoneNumberErrorMsg={errors.contactInfoSection?.phoneNumber?.message}
          phoneNumberLabel={dictionary.secondSectionFirstInput}
        />
        <Stack
          sx={{
            whiteSpace: 'nowrap',
          }}
        >
          <PhoneNumber
            phoneNumberFormName='contactInfoSection.extraPhoneNumber'
            phoneNumberPrefixFormName='contactInfoSection.extraPhonePrefixRelationId'
            phoneNumberErrorMsg={
              errors.contactInfoSection?.extraPhoneNumber?.message
            }
            phoneNumberError={Boolean(
              errors.contactInfoSection?.extraPhoneNumber
            )}
            phoneNumberLabel={dictionary.secondSectionSecondInput}
            disabled={Boolean(hasNoExtraPhoneNumber)}
          />
          <CustomCheckbox
            name={'contactInfoSection.hasNoExtraPhoneNumber'}
            label={dictionary.secondSectionNoExtraPhoneNumber}
          />
        </Stack>
        <Stack>
          <TextField
            role={
              Boolean(errors.contactInfoSection?.mail) ? 'alert' : undefined
            }
            id={dictionary.secondSectionThirdInput}
            type='email'
            inputProps={{
              maxLength: '50',
            }}
            {...register('contactInfoSection.mail')}
            error={
              Boolean(errors.contactInfoSection?.mail) && hasNoMail === false
            }
            label={dictionary.secondSectionThirdInput}
            {...textFieldShrink(mail)}
            helperText={
              Boolean(errors.contactInfoSection?.mail) &&
              hasNoMail === false &&
              generateError(
                dictionary.secondSectionThirdInput,
                errors.contactInfoSection?.mail?.message!
              )
            }
            disabled={typeof hasNoMail === 'boolean' ? hasNoMail : false}
            sx={styleTextField}
          />
          <CustomCheckbox
            name={'contactInfoSection.hasNoMail'}
            label={dictionary.secondSectionNoEmail}
          />
        </Stack>
      </Stack>
    </FormSection>
  );
};
